const cartBody = document.querySelector('.checkout-cart__body')


function isScrollable(element) {
    return element.scrollWidth > element.clientWidth || element.scrollHeight > element.clientHeight;
};

function isScrollableX(element) {
    return element.scrollWidth > element.clientWidth;
};

function isScrollableY(element) {
    return element.scrollHeight > element.clientHeight;
};

export default function() {
    if(cartBody) {
        let lineItems = cartBody.querySelector('.line-items');
        // Add "is-scrollable" class to cartBody whenever the lineitems are scrollable.
        isScrollableY(lineItems) && cartBody.classList.add('is-scrollable');
    }
}